const defaultPayload = { goalTerminology: 'GOAL' }

export default defaultPayload



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/perform_settings/shared/defaultPayload.js